/**
 * Peppar Theme Colors
 * Centralized color definitions for the React application
 */

import { brandFaviconUrl, brandLogoUrl } from '../constants/images';

export const theme = {
  colors: {
    primary: '#F5C21A',
    primaryHover: '#D4A416',
    primaryText: '#1F2428',

    secondary: '#1F2428',

    background: '#FFFFFF',
    surface: '#F8F9FA',

    navbarBackground: '#FFFFFF',
    pageBackground: '#FFFFFF',
    cardBackground: '#FFFFFF',

    footerBackground: '#1F2428',
    footerBorder: '#F5C21A',

    text: {
      primary: '#1F2428',
      secondary: '#4B5563',
      muted: '#6B7280',
    },
    textPrimary: '#1F2428',
    textSecondary: '#4B5563',
    textMuted: '#6B7280',
    textLight: '#FFFFFF',

    borderColor: '#E9ECEF',
    shadow: 'rgba(0, 0, 0, 0.08)',
    shadowHover: 'rgba(0, 0, 0, 0.12)',

    success: '#16A34A',
    warning: '#F59E0B',
    error: '#DC2626',
    info: '#2563EB',
  },

  fonts: {
    family: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    headingWeight: 700,
    bodyWeight: 400,
    buttonWeight: 600,
  },

  get logo() {
    return {
      url: brandLogoUrl(),
      favicon: brandFaviconUrl(),
    };
  },
};

export type Theme = typeof theme;
